import axiosClient from './axiosClient';

export const newsService = {
  /**
   * Fetch the latest IPO and primary-market news headlines
   */
  getNews: async () => {
    const response = await axiosClient.get('/api/market/news');
    return response.data;
  },
};

export default newsService;
